import React from 'react';
import Hero from '../components/Hero';
import NightsStrip from '../components/sections/NightsStrip';
import Values from '../components/sections/Values';
import ReviveStatement from '../components/sections/ReviveStatement';
import InstagramFeed from '../components/sections/InstagramFeed';
import FollowJourney from '../components/sections/FollowJourney';
import FAQAccordion from '../components/FAQAccordion';
import { FAQS } from '../data/faqs';
import { Link } from 'react-router-dom';
import usePageMeta from '../hooks/usePageMeta';
import styles from './Home.module.css';

export default function Home({ onNewsletter }) {
  usePageMeta(
    'Revive Worship — Worshipping. Everywhere.',
    'A Pittsburgh worship ministry gathering once a month in public spaces to worship Jesus unashamed. Find the next Revive Night.'
  );

  return (
    <>
      <Hero />
      <NightsStrip />
      <Values />
      <ReviveStatement />
      <InstagramFeed />

      <section id="faq" className={styles.faqSection}>
        <div className={styles.faqShell}>
          <div className={styles.faqHead}>
            <h2 className={styles.faqTitle}>FAQs.</h2>
            <Link to="/faq" className={styles.faqAll}>
              See all questions <span aria-hidden="true">↗</span>
            </Link>
          </div>
          <div className={styles.faqList}>
            <FAQAccordion items={FAQS.slice(0, 6)} defaultOpen={-1} />
          </div>
        </div>
      </section>

      <FollowJourney onNewsletter={onNewsletter} />
    </>
  );
}
